import { combineReducers, configureStore } from '@reduxjs/toolkit';
import {
  groupsReducer,
  promoReducer,
  schedulePublicReducer,
  teachersReducer,
  viewStageReducer,
  yaSmartCaptchaReducer,
} from 'entities/index';

import { captchaMiddleware } from './middleware';

const rootReducer = combineReducers({
  groupsReducer,
  promoReducer,
  schedulePublicReducer,
  teachersReducer,
  viewStageReducer,
  yaSmartCaptchaReducer,
});

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat(captchaMiddleware),
  devTools: !import.meta.env.PROD,
});

export { store };
